
import SideNavigation from './SideNavigation';

export { Props } from './SideNavigation';
export default SideNavigation;
